<script>
import axios from 'axios'
export default {
  name: 'utils',
  methods: {
    logout: function (that) {
      axios.get('/api/users/logout').then(res => {
        if (res.status === 200) {
          that.$root.$data.validated = false
          that.$root.$data.user = null
          that.$root.$data.pageTitle = ''
          that.$router.push('/')
        }
      })
    },
    sleep: function (ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },
    delay: async function (ms, fn) {
      await this.sleep(ms)
      fn()
    },
    getData: function (path, fn) {
      axios.get(path).then(res => { fn(res.data) }).catch(err => { console.log(err) })
    },
    // Return true if all the fields in obj have a non-zero trimmed length, excluding those in [ignore]
    allFields: function (obj, ignore) {
      ignore = ignore || []
      for (var key in obj) {
        if (typeof obj[key] === 'string' && ignore.indexOf(key) < 0) {
          obj[key] = obj[key].trim()
          if (!obj[key]) return false
        }
      }
      return true
    },
    importType: function (string) {
      var lines = string.split(';;')
      var secKey = 0
      var subKey = 0
      var vtype = {
        name: lines[0].split('visatype')[1].trim(),
        sections: []
      }

      var newSec = function (line) {
        vtype.sections.push({
          name: line.split('# ')[1].trim(),
          ref: Math.round(Math.random() * 100000),
          subsections: []
        })
        secKey = vtype.sections.length - 1
      }

      var newSub = function (line) {
        line = line.slice(3).split('||').map(f => { return f.trim() })
        vtype.sections[secKey].subsections.push({
          name: line[0],
          ref: Math.round(Math.random() * 100000),
          repeatable: line.length >= 2 && line[1] === 'repeatable',
          questions: []
        })
        subKey = vtype.sections[secKey].subsections.length - 1
      }

      var newQ = function (line) {
        var fields = line.split('||').map(f => { return f.trim() })
        if (fields.length < 4) return
        vtype.sections[secKey].subsections[subKey].questions.push({
          ref: Math.round(Math.random() * 100000),
          type: fields[0],
          text: fields[1],
          helptext: fields[2] === '_' ? '' : fields[2],
          // immifield: fields[3] === '_' ? '' : fields[3],
          selectVals: [],
          dependent: false,
          depends: {
            ref: '',
            atxt: ''
          }
        })
      }

      lines.slice(1).forEach(line => {
        line = line.trim()
        if (line.startsWith('# ')) newSec(line)
        else if (line.startsWith('## ')) newSub(line)
        else if (line.trim() === '') return
        else newQ(line)
      })

      return vtype
    },
    // Generate a list of invoice payments
    payments: function (inv) {
      if (!inv.plan) return null
      var payments = []

      // Payments that have occurred
      for (let p of inv.payments) {
        payments.push({
          date: new Date(p.time).toLocaleDateString('en-GB'),
          amount: p.amount,
          paid: true
        })
      }

      // Calculate future payments
      if (!inv.paid) {
        var outstanding = inv.outstanding
        var period = 1000 * 60 * 60 * 24 * 28 // milliseconds in 28 days
        var firstUpcoming = true // To mark the first upcoming payment
        var time, amount
        var lastpayment = new Date(inv.last_payment).getTime()

        if (lastpayment > 0) {
          time = lastpayment
        } else {
          // Account for the upoming downpayment
          time = new Date(inv.date).getTime()
          amount = inv.initial
          payments.push({
            date: new Date(time).toLocaleDateString('en-GB'),
            amount: amount,
            paid: false,
            firstUpcoming: firstUpcoming
          })
          outstanding -= amount
          time += period
          firstUpcoming = false
        }

        while (outstanding > 0) {
          amount = Math.min(outstanding, inv.monthly)
          outstanding -= amount
          time += period

          payments.push({
            date: new Date(time).toLocaleDateString('en-GB'),
            amount: amount,
            paid: false,
            firstUpcoming: firstUpcoming
          })
          firstUpcoming = false
        }
      }

      return payments
    },
    // May be working
    checkMatter: function (visatype, matter, answers) {
      let isNeededSub = (sub) => {
        if (!sub.for_client) {
          return false
        }
        if (!sub.depends || !sub.depends.ref) {
          console.log(sub.name)
          return true
        } else {
          // Check if the dependent question has been answered
          let ref = sub.depends.ref
          let atxt = sub.depends.atxt
          if (answers[ref] && answers[ref].length > 0) {
            // Check if any of the answers match the needed atxt
            for (const i in answers[ref]) {
              if (answers[ref][i].atxt === atxt) {
                return true
              }
            }
          } else {
            // Question has been unanswered, so sub is not needed
            return false
          }
        }
      }

      let isAnswered = (q) => {
        let arr = answers[q.ref]
        if (arr && arr.length > 0) {
          return true
        } else {
          return false
        }
      }

      for (const i in visatype.sections) {
        let sec = visatype.sections[i]
        for (const j in sec.subsections) {
          let sub = sec.subsections[j]
          if (isNeededSub(sub)) {
            console.log(sub.name)
            for (const k in sub.questions) {
              let q = sub.questions[k]
              if (!isAnswered(q)) {
                return
              }
            }
          }
        }
      }

      console.log('All required questions answered')

      // Notify the admins
      axios.post('/api/matters/markallcqanswered/' + matter._id)
    }
  },
  countries: function () {
    return {
      'Select': '',
      'AFGHANISTAN': 'AFG',
      'ALBANIA': 'ALB',
      'ALGERIA': 'DZA',
      'AMERICAN SAMOA': 'ASM',
      'ANDORRA': 'AND',
      'ANGOLA': 'AGO',
      'ANGUILLA': 'AIA',
      'ANTARCTICA': 'ATA',
      'ANTIGUA AND BARBUDA': 'ATG',
      'ARGENTINA': 'ARG',
      'ARMENIA': 'ARM',
      'ARUBA': 'ABW',
      'AUSTRALIA': 'AUS',
      'AUSTRIA': 'AUT',
      'AZERBAIJAN': 'AZE',
      'BAHAMAS': 'BHS',
      'BAHRAIN': 'BHR',
      'BANGLADESH': 'BGD',
      'BARBADOS': 'BRB',
      'BELARUS': 'BLR',
      'BELGIUM': 'BEL',
      'BELIZE': 'BLZ',
      'BENIN': 'BEN',
      'BERMUDA': 'BMU',
      'BHUTAN': 'BTN',
      'BOLIVIA': 'BOL',
      'BONAIRE, SINT EUSTATIUS AND SABA': 'BES',
      'BOSNIA AND HERZEGOVINA': 'BIH',
      'BOTSWANA': 'BWA',
      'BOUVET ISLAND': 'BVT',
      'BRAZIL': 'BRA',
      'BRIT INDIAN OCN TERR': 'IOT',
      'BRUNEI DARUSSALAM': 'BRN',
      'BULGARIA': 'BGR',
      'BURKINA FASO': 'BFA',
      'BURMA (MYANMAR)': 'MMR',
      'BURUNDI': 'BDI',
      'CABO VERDE': 'CPV',
      'CAMBODIA': 'KHM',
      'CAMEROON': 'CMR',
      'CANADA': 'CAN',
      'CAYMAN ISLANDS': 'CYM',
      'CENTRAL AFRICAN REPUBLIC': 'CAF',
      'CHAD': 'TCD',
      'CHILE': 'CHL',
      'CHINA': 'CHN',
      'COCOS (KEELING) ISL.': 'CCK',
      'COLOMBIA': 'COL',
      'COMOROS': 'COM',
      'CONGO': 'COG',
      'CONGO, DEMOCRATIC REPUBLIC OF THE': 'COD',
      'COOK ISLANDS': 'COK',
      'COSTA RICA': 'CRI',
      'COTE D\'IVOIRE': 'CIV',
      'CROATIA': 'HRV',
      'CUBA': 'CUB',
      'CURACAO': 'CUW',
      'CYPRUS': 'CYP',
      'CZECHIA (CZECH REP)': 'CZE',
      'CZECHOSLOVAKIA': 'CSK',
      'DENMARK': 'DNK',
      'DJIBOUTI': 'DJI',
      'DOMINICA': 'DMA',
      'DOMINICAN REPUBLIC': 'DOM',
      'EAST TIMOR': 'TMP',
      'ECUADOR': 'ECU',
      'EGYPT': 'EGY',
      'EL SALVADOR': 'SLV',
      'EQUATORIAL GUINEA': 'GNQ',
      'ERITREA': 'ERI',
      'ESTONIA': 'EST',
      'ETHIOPIA': 'ETH',
      'FALKLAND ISLANDS (MALVINAS)': 'FLK',
      'FAROE ISLANDS': 'FRO',
      'FIJI': 'FJI',
      'FINLAND': 'FIN',
      'FRANCE': 'FRA',
      'FRANCE, METROPOLITAN': 'FXX',
      'FRENCH GUIANA': 'GUF',
      'FRENCH POLYNESIA': 'PYF',
      'FRENCH SOUTHERN TERR': 'ATF',
      'GABON': 'GAB',
      'GAMBIA': 'GMB',
      'GEORGIA': 'GEO',
      'GEORGIA/SANDWICH ISL': 'SGS',
      'GERMANY': 'D',
      'GHANA': 'GHA',
      'GIBRALTAR': 'GIB',
      'GREECE': 'GRC',
      'GREENLAND': 'GRL',
      'GRENADA': 'GRD',
      'GUADELOUPE': 'GLP',
      'GUAM': 'GUM',
      'GUATEMALA': 'GTM',
      'GUINEA': 'GIN',
      'GUINEA-BISSAU': 'GNB',
      'GUYANA': 'GUY',
      'HAITI': 'HTI',
      'HEARD ISLAND AND MCDONALD ISLANDS': 'HMD',
      'HONDURAS': 'HND',
      'HONG KONG SAR': 'HKG',
      'HUNGARY': 'HUN',
      'ICELAND': 'ISL',
      'INDIA': 'IND',
      'INDONESIA': 'IDN',
      'IRAN, ISLAMIC REPUBLIC OF': 'IRN',
      'IRAQ': 'IRQ',
      'IRELAND': 'IRL',
      'ISRAEL': 'ISR',
      'ITALY': 'ITA',
      'JAMAICA': 'JAM',
      'JAPAN': 'JPN',
      'JORDAN': 'JOR',
      'KAZAKHSTAN': 'KAZ',
      'KENYA': 'KEN',
      'KIRIBATI': 'KIR',
      'KOREA, DEMOCRATIC PEOPLES REPUBLIC OF (NORTH)': 'PRK',
      'KOREA, REPUBLIC OF (SOUTH)': 'KOR',
      'KOSOVO': 'RKS',
      'KUWAIT': 'KWT',
      'KYRGYZSTAN': 'KGZ',
      'LAO PEOPLE\'S DEMOCRATIC REPUBLIC': 'LAO',
      'LATVIA': 'LVA',
      'LEBANON': 'LBN',
      'LESOTHO': 'LSO',
      'LIBERIA': 'LBR',
      'LIBYA': 'LBY',
      'LIECHTENSTEIN': 'LIE',
      'LITHUANIA': 'LTU',
      'LUXEMBOURG': 'LUX',
      'MACAU SAR': 'MAC',
      'MACEDONIA, FORMER YUGOSLAV REPUBLIC OF': 'MKD',
      'MADAGASCAR': 'MDG',
      'MALAWI': 'MWI',
      'MALAYSIA': 'MYS',
      'MALDIVES': 'MDV',
      'MALI': 'MLI',
      'MALTA': 'MLT',
      'MARSHALL ISLANDS': 'MHL',
      'MARTINIQUE': 'MTQ',
      'MAURITANIA': 'MRT',
      'MAURITIUS': 'MUS',
      'MAYOTTE': 'MYT',
      'MEXICO': 'MEX',
      'MICRONESIA, FEDERATED STATES OF': 'FSM',
      'MOLDOVA, REPUBLIC OF': 'MDA',
      'MONACO': 'MCO',
      'MONGOLIA': 'MNG',
      'MONTENEGRO': 'MNE',
      'MONTSERRAT': 'MSR',
      'MOROCCO': 'MAR',
      'MOZAMBIQUE': 'MOZ',
      'NAMIBIA': 'NAM',
      'NAURU': 'NRU',
      'NEPAL': 'NPL',
      'NETHERLANDS': 'NLD',
      'NETHERLANDS ANTILLES': 'ANT',
      'NEUTRAL ZONE': 'NTZ',
      'NEW CALEDONIA': 'NCL',
      'NEW ZEALAND': 'NZL',
      'NICARAGUA': 'NIC',
      'NIGER': 'NER',
      'NIGERIA': 'NGA',
      'NIUE': 'NIU',
      'NORTHERN MARIANA ISL': 'MNP',
      'NORWAY': 'NOR',
      'OMAN': 'OMN',
      'PAKISTAN': 'PAK',
      'PALAU': 'PLW',
      'PALESTINIAN AUTHORITY': 'PSE',
      'PANAMA': 'PAN',
      'PAPUA NEW GUINEA': 'PNG',
      'PARAGUAY': 'PRY',
      'PERU': 'PER',
      'PHILIPPINES': 'PHL',
      'PITCAIRN': 'PCN',
      'POLAND': 'POL',
      'PORTUGAL': 'PRT',
      'PUERTO RICO': 'PRI',
      'QATAR': 'QAT',
      'REFUGEE AS PER ART 1': 'XXB',
      'REFUGEE OTHER': 'XXC',
      'REUNION': 'REU',
      'ROMANIA': 'ROU',
      'ROMANIA PRE 1/2/2002': 'ROM',
      'RUSSIAN FEDERATION': 'RUS',
      'RWANDA': 'RWA',
      'SAINT HELENA, ASCENSION AND TRISTAN DA CUNHA': 'SHN',
      'SAINT KITTS AND NEVIS': 'KNA',
      'SAINT LUCIA': 'LCA',
      'SAINT VINCENT AND THE GRENADINES': 'VCT',
      'SAMOA': 'WSM',
      'SAN MARINO': 'SMR',
      'SAO TOME AND PRINCIPE': 'STP',
      'SAUDI ARABIA': 'SAU',
      'SENEGAL': 'SEN',
      'SERBIA': 'SRB',
      'SERBIA AND MONTENEGRO': 'SCG',
      'SEYCHELLES': 'SYC',
      'SIERRA LEONE': 'SLE',
      'SINGAPORE': 'SGP',
      'SINT MAARTEN (DUTCH PART)': 'SXM',
      'SLOVAK REPUBLIC': 'SVK',
      'SLOVENIA': 'SVN',
      'SOLOMON ISLANDS': 'SLB',
      'SOMALIA': 'SOM',
      'SOUTH AFRICA': 'ZAF',
      'SOUTH SUDAN': 'SSD',
      'SPAIN': 'ESP',
      'SRI LANKA': 'LKA',
      'ST PIERRE & MIQUELON': 'SPM',
      'STATELESS PERSON': 'XXA',
      'SUDAN': 'SDN',
      'SURINAME': 'SUR',
      'SVALBARD & JAN MAYEN': 'SJM',
      'SWAZILAND': 'SWZ',
      'SWEDEN': 'SWE',
      'SWITZERLAND': 'CHE',
      'SYRIAN ARAB REPUBLIC': 'SYR',
      'TAIWAN': 'TWN',
      'TAJIKISTAN': 'TJK',
      'TANZANIA, UNITED REPUBLIC OF': 'TZA',
      'THAILAND': 'THA',
      'TIMOR-LESTE': 'TLS',
      'TOGO': 'TGO',
      'TOKELAU': 'TKL',
      'TONGA': 'TON',
      'TRINIDAD AND TOBAGO': 'TTO',
      'TUNISIA': 'TUN',
      'TURKEY': 'TUR',
      'TURKMENISTAN': 'TKM',
      'TURKS AND CAICOS ISLANDS': 'TCA',
      'TUVALU': 'TUV',
      'U.S MINOR ISLANDS': 'UMI',
      'UGANDA': 'UGA',
      'UKRAINE': 'UKR',
      'UNITED ARAB EMIRATES': 'ARE',
      'UNITED KINGDOM - BRITISH CITIZEN': 'GBR',
      'UNITED KINGDOM - BRITISH NATIONAL (OVERSEAS)': 'GBN',
      'UNITED KINGDOM - BRITISH OVERSEAS CITIZEN': 'GBO',
      'UNITED KINGDOM - BRITISH OVERSEAS TERRITORIES CITIZEN': 'GBD',
      'UNITED KINGDOM - BRITISH PROTECTED PERSON': 'GBP',
      'UNITED KINGDOM - BRITISH SUBJECT': 'GBS',
      'UNITED NATIONS AGNCY': 'UNA',
      'UNITED NATIONS ORGANISATION': 'UNO',
      'UNITED STATES': 'USA',
      'UNMIK TRAVEL DOC': 'UNK',
      'UNSPCFED NATIONALITY': 'XXX',
      'URUGUAY': 'URY',
      'UZBEKISTAN': 'UZB',
      'VANUATU': 'VUT',
      'VATICAN CITY STATE (HOLY SEE)': 'VAT',
      'VENEZUELA': 'VEN',
      'VIET NAM': 'VNM',
      'VIRGIN ISLANDS (BRITISH)': 'VGB',
      'VIRGIN ISLANDS (U.S.)': 'VIR',
      'WALLIS & FUTUNA ISL': 'WLF',
      'WESTERN SAHARA': 'ESH',
      'YEMEN': 'YEM',
      'YUGOSLAVIA': 'YUG',
      'ZAIRE': 'ZAR',
      'ZAMBIA': 'ZMB',
      'ZIMBABWE': 'ZWE'
    }
  },
  vevoFields: function () {
    // These match the keys returned by dyb (excluding visa conditions)
    return {
      visaDesc: 'Visa description',
      visaClass: 'Visa class',
      visaType: 'Visa type',
      visaStatus: 'Visa status',
      visaApplicant: 'Visa applicant',
      visaGrantDate: 'Visa grant date',
      visaExpDate: 'Visa expiry date',
      location: 'Location',
      grantNumber: 'Grant number',
      entriesAllowed: 'Entries allowed',
      notArriveAfter: 'Must not arrive after',
      stayPeriod: 'Period of stay'
    }
  },
  sources: function () {
    return [
      'Google Organic',
      'Google SEM',
      'Facebook',
      'LinkedIn',
      'Referral',
      'Other'
    ]
  },
  dybURL: function () {
    if (process.env.NODE_ENV === 'development') {
      return 'http://localhost:8082/vevo?'
    } else {
      return 'https://staging.pocketlegal.com.au:8082/vevo?'
    }
  },
  brands: function () {
    return {
      'pl': 'PocketLegal',
      'ie': 'Immigration Experts'
    }
  },
  invoiceItems: function () {
    return [
      'Initial work on application',
      'Standard Business Sponsorship',
      'Primary',
      'Nomination',
      'Balance of account',
      'Other'
    ]
  }
}
</script>



// WEBPACK FOOTER //
// utils.vue?244d17de